import i18n from "@/i18n";

export function isArabicUi() {
  return String(i18n.language || "").toLowerCase().startsWith("ar");
}

export function displayItemName(item) {
  if (!item) return "";
  const en = item.item_name || item.name || "";
  const ar = item.item_name_ar || item.name_ar || "";
  if (isArabicUi()) return ar || en;
  return en || ar;
}

export function itemNameSecondary(item) {
  if (!item) return "";
  const en = item.item_name || item.name || "";
  const ar = item.item_name_ar || item.name_ar || "";
  if (isArabicUi()) return ar && en && ar !== en ? en : "";
  return ar && ar !== en ? ar : "";
}
